import React from 'react';
import Head from '../layout/head.jsx'
import Content from '../layout/content.jsx'
import Form from '../layout/form.jsx'
import Loader from '../layout/loader.jsx'
import { toast } from 'react-toastify'
import API from '../../services/api.jsx'

class AffiliateNew extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			loading: false,
			breadcrumb: {title: 'back to Affiliate list', path: '/affiliates'},
			fields: {
				name: { label: 'Name', type: 'text', required: true },
			},
			entity: {
				name: null
			}
		}
		this.saveEntity = this.saveEntity.bind(this)
	}

	saveEntity(fields) {
		this.setState({ loading: true })
		fields.assets = []
		API.create('affiliates', fields).then(() => {
			toast.success('Affiliate has been created')
			this.props.history.push('/affiliates')
		}).catch(() => {
			// toast.error('An unexpected error has occured, please try again')
			this.setState({ loading: false })
		})
	}

	render() {
		if(this.state.loading)
			return <Loader />
		else
			return <>
				<Head title={'Create new affiliate'} breadcrumb={this.state.breadcrumb} />
				<Content>
					<Form fields={this.state.fields} cancel={() => this.props.history.push('/affiliates')} save={this.saveEntity} entity={this.state.entity} />
				</Content>
			</>
	}
}

export default AffiliateNew;
